<template>
  <v-row justify="center">
    <v-dialog v-model="openIvoiceDialog" max-width="1000" persistent>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" v-if="!invoiceDoc">
              <v-sheet color="grey" class="pa-3">
                <v-skeleton-loader
                  class="mx-auto"
                  max-width="300"
                  type="card"
                ></v-skeleton-loader>
              </v-sheet>
            </v-col>
            <v-col v-if="invoiceDoc" cols="12">
              <iframe
                title="Proforma Invoice Document"
                :src="invoiceDoc"
                width="100%"
                height="800px"
              ></iframe>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="openIvoiceDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "InvoiceDialog",
  mounted() {
    window.document.title = "KISEB::Invoice Proforma";
  },
  computed: {
    invoiceDoc() {
      return this.$store.getters["Renewal/renewalGetters"]("renewal_document");
    },
    openIvoiceDialog: {
      get() {
        return this.$store.getters["Renewal/renewalGetters"](
          "openIvoiceDialog",
        );
      },
      set(value) {
        this.$store.commit("Renewal/MUTATE", {
          state: "openIvoiceDialog",
          data: value,
        });
      },
    },
  },
};
</script>
